import { brouillon2Facture } from '@/api/facture';

export default async function saveMultiFacture(facturesToSave) {
  let nbFactureSave = 0;
  const errors = [];

  facturesToSave.sort((a, b) => {
    const firstLevel = new Date(a.dateDevisCommande) - new Date(b.dateDevisCommande);
    if (firstLevel !== 0) return firstLevel;
    return new Date(a.creationTime) - new Date(b.creationTime);
  });
  for (let i = 0; i < facturesToSave.length; i += 1) {
    try {
      // eslint-disable-next-line
      await brouillon2Facture(facturesToSave[i].id);
      nbFactureSave += 1;
    } catch (e) {
      errors.push({
        isLink: true,
        libelle: facturesToSave[i].code,
        params: { id: facturesToSave[i].id },
        routeName: 'c.bodac.factures',
      });
      break;
    }
  }
  return { nbFactureSave: nbFactureSave, errors: errors };
}
